import gql from "graphql-tag";
import { entityCommentFragment } from "./fragments";

export const ADD_ENTITY_COMMENT = gql`
  mutation AddEntityComment(
    $entityType: CommentEntityType!
    $entityId: ID!
    $message: String!
  ) {
    addEntityComment(
      entityType: $entityType
      entityId: $entityId
      message: $message
    ) {
      status
      error
      data {
        ...EntityCommentFragment
      }
    }
  }
  ${entityCommentFragment}
`;

export const UPDATE_ENTITY_COMMENT = gql`
  mutation UpdateEntityComment($id: ID!, $message: String!) {
    updateEntityComment(id: $id, message: $message) {
      status
      error
      data {
        ...EntityCommentFragment
      }
    }
  }
  ${entityCommentFragment}
`;

export const DELETE_ENTITY_COMMENT = gql`
  mutation DeleteEntityComment($id: ID!) {
    deleteEntityComment(id: $id) {
      status
      error
      data {
        ...EntityCommentFragment
      }
    }
  }
  ${entityCommentFragment}
`;
